export default __webpack_public_path__ + "static/media/cake3.afe81a04.jpg";